// extracted by mini-css-extract-plugin
export default {"dropdown":"DropdownMenu_dropdown__-MNer"};